import { apiBaseUrl } from './config.js';
import { clearCreds, readCreds } from './creds.js';
import { login } from './auth.js';
import { deviceLogin } from './device.js';
import { color, error, info, line } from './ui.js';

/**
 * `futurex login` — sign in. Default is the browser "link code" device flow
 * (no password in the terminal). If both `--email` and `--password` (or the
 * `FUTUREX_EMAIL`/`FUTUREX_PASSWORD` env vars) are supplied, the legacy
 * password login is used instead — kept only for non-interactive CI.
 */
export async function runLogin(flags: Record<string, string | boolean>): Promise<void> {
  const email = typeof flags.email === 'string' ? flags.email : process.env.FUTUREX_EMAIL;
  const password = typeof flags.password === 'string' ? flags.password : process.env.FUTUREX_PASSWORD;

  try {
    if (email && password) {
      const creds = await login(email, password);
      info(`logged in as ${creds.email ?? email} · ${apiBaseUrl()}`);
      return;
    }
    const creds = await deviceLogin({ noBrowser: flags['no-browser'] === true });
    info(`logged in as ${creds.email ?? 'your account'} · ${apiBaseUrl()}`);
  } catch (err) {
    error(err instanceof Error ? err.message : String(err));
    process.exitCode = 1;
  }
}

/** `futurex logout` — clear stored credentials. */
export function runLogout(): void {
  clearCreds();
  info('logged out');
}

/** `futurex whoami` — show the current auth/backend mode. */
export function runWhoami(): void {
  const creds = readCreds();
  if (!creds?.accessToken) {
    line('not signed in — run `futurex login`');
    return;
  }
  line(`${color.bold(creds.email ?? 'unknown')} · gateway ${creds.apiUrl}`);
}
